import { render, staticRenderFns } from "./CampaignTriggers.vue?vue&type=template&id=145c2e62"
import script from "./CampaignTriggers.vue?vue&type=script&lang=js"
export * from "./CampaignTriggers.vue?vue&type=script&lang=js"
import style0 from "./CampaignTriggers.vue?vue&type=style&index=0&id=145c2e62&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports